import { enqueueSnackbar } from 'notistack';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Navigate, redirect } from 'react-router-dom';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));

  const isAuthenticated = () => {
    if (localStorage.getItem('authenticated')) return true;
    return false
  }

  async function requireAuth() {
    const isLoggedIn = localStorage.getItem("authenticated")
    
    if (!isLoggedIn || !user.routes) {
      throw redirect("/login")
    }

    return null
  }

  async function requirePermission(permissions, route) {
    if (!user || !user.routes) {
      throw redirect("/login")
    }

    if (permissions.length == 0) return null

    if (!permissions.includes(route)) {
      throw redirect("/permissionDenied")
    }

    return null
  }

  return (
    <AuthContext.Provider
      value={{
        user: user,
        setUser: setUser,
        isAuthenticated,
        requireAuth,
        requirePermission
      }}>
      {children}
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);
  
  if (!context) {
    enqueueSnackbar('Erro ao realizar autenticação', { variant: 'error' });
    throw new Error('Erro ao realizar autenticação');
  }

  return context;
}
  
  export { AuthProvider, useAuth };